import { render, staticRenderFns } from "./batch_scheme.vue?vue&type=template&id=613ccdf4"
import script from "./batch_scheme.vue?vue&type=script&lang=js"
export * from "./batch_scheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports